import React from 'react';
import { Content, Label, Flex, Text, Button, FileInput } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { Export } from "../../utils/index.js";
import S from './Pair.css';
const {
  t
} = I18N.ns('pairing.bulkPairing.views.FileForm');
export default class FileForm extends React.Component {
  onSubmit = async event => {
    const {
      onSubmit,
      loading
    } = this.props;
    if (loading) {
      return;
    }
    onSubmit(event);
  };
  downloadTemplate = evt => {
    const {
      parentKey,
      objectKey,
      unpair
    } = this.props;
    let template = `${parentKey},${objectKey}`;
    if (unpair) {
      template = parentKey;
    }
    Export.exportFile(template, t('fileName'));
  };
  onCSVSelect = async evt => {
    const file = evt?.value[0];
    const result = await file.text();
    const {
      updateState
    } = this.props;
    updateState({
      data: evt.data,
      value: result
    });
    updateState({
      data: `${evt.data}FileName`,
      value: file.name
    });
  };
  render() {
    const {
      loading,
      data,
      onCancel,
      unpair,
      fileName
    } = this.props;
    return /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Content.Area, {
      variant: "formBody"
    }, /*#__PURE__*/React.createElement(Flex, {
      className: S.header,
      variant: "colM",
      align: "flex-start"
    }, /*#__PURE__*/React.createElement(Text, {
      variant: "formTitle"
    }, t('title')), /*#__PURE__*/React.createElement(Text, {
      variant: "bodySmall"
    }, t('body')), /*#__PURE__*/React.createElement(Button, {
      icon: "fa fa-download",
      variant: "link",
      onClick: this.downloadTemplate,
      style: {
        paddingLeft: 0
      }
    }, /*#__PURE__*/React.createElement("span", null, t('downloadButtonText', {
      type: unpair ? 'Unpair' : 'Pair'
    }), " "))), /*#__PURE__*/React.createElement("div", {
      className: S.pairItem
    }, /*#__PURE__*/React.createElement(Label, {
      variant: "inputTitle"
    }, t('inputTitle')), /*#__PURE__*/React.createElement(Flex, {
      variant: "rowS",
      align: "center"
    }, /*#__PURE__*/React.createElement(FileInput, {
      variant: "secondary",
      eventData: "csv",
      fileTypes: ['.csv', '.tsv'],
      onChange: this.onCSVSelect
    }, t('csvButtonText')), fileName && /*#__PURE__*/React.createElement(Text, {
      variant: "body"
    }, fileName)))), /*#__PURE__*/React.createElement(Content.Footer, {
      variant: "formButtons",
      className: S.pairButtons
    }, /*#__PURE__*/React.createElement(Flex, {
      variant: "rowMEnd"
    }, typeof onCancel === 'function' && /*#__PURE__*/React.createElement(Flex, {
      variant: "rowMEnd"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: onCancel,
      variant: "primaryCancel"
    }, loading ? /*#__PURE__*/React.createElement("i", {
      className: "fa fa-spin fa-spinner"
    }) : t('cancelText'))), /*#__PURE__*/React.createElement(Flex, {
      variant: "rowMEnd"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: this.onSubmit,
      disabled: !data,
      eventData: data,
      className: S.submit,
      variant: "primary"
    }, loading ? /*#__PURE__*/React.createElement("i", {
      className: "fa fa-spin fa-spinner"
    }) : t('submit'))), /*#__PURE__*/React.createElement(Text, {
      variant: "inputCaptionSmallError"
    }))));
  }
}